import React from 'react'
import { IconInfoCircle } from '@edulastic/icons'
import { RangeSlider } from '@edulastic/common'
import { FilterSubHeadingContainer, MasteryRangeContainer } from './style'
import { CustomTableTooltip } from '../../../Reports/common/components/customTableTooltip'
import { TooltipContainer } from '../StudentList/style'

const MasteryRangeFilter = ({ masteryRange, setMasteryRange }) => {
  return (
    <MasteryRangeContainer>
      <FilterSubHeadingContainer>
        Standards mastery range{' '}
        <CustomTableTooltip
          title={
            <TooltipContainer isLight>
              Choose standards needing improvement by using the mastery range.
              For example, selecting 0-30% will filter and display standards
              with mastery below 30% for each student in the right-side table.
            </TooltipContainer>
          }
          getCellContents={() => <IconInfoCircle width="16px" height="16px" />}
        />
      </FilterSubHeadingContainer>
      <RangeSlider
        masteryRange={masteryRange}
        setMasteryRange={setMasteryRange}
      />
    </MasteryRangeContainer>
  )
}

export default MasteryRangeFilter
